export class Price {
    public base     : number = 0.0;
    public foreign  : number = 0.0;
}